import puzzles from '../src/images/puzzles.png'
import realEstate from '../src/images/HomeChoice_properties.png'
import chopfood from '../src/images/CHOPFOOD_HOME.png'
import project from '../src/images/project.png'
import responsive from "../src/images/responsive.png"
import login from "../src/images/login.png"
import worldfood from "../src/images/worldfood.png"
import firekicks from "../src/images/firekicks.png"
import aventon from "../src/images/aventon.png"
import ileojajobs from "../src/images/ileojajobs.png"
import ileojaacademy from "../src/images/ileojaacademy.png"
import electric_shaver from "../src/images/electric_shaver.png"
import cleaning_gel from "../src/images/cleaning_gel.png"



export const cardlist = [{
        id: 1,
        img: puzzles,
        link: "#",
        status: "Under construction"
    },
    {
        id: 2,
        img: realEstate,
        link: "https://home-choice.vercel.app/",
        status: "Live"
    },
    {
        id: 3,
        img: worldfood,
        link: "http://worldfood.lovestoblog.com/",
        status: "live"
    },
    {
        id: 4,
        img: firekicks,
        link: "https://firekicks.lovestoblog.com/",
        status: "live"
    },
    {
        id: 5,
        img: chopfood,
        link: "#",
        status: "Webpage(static)"
    },
    {
        id: 6,
        img: project,
        link: "#",
        status: "Webpage(static)"
    },
    {
        id: 7,
        img: responsive,
        link: "#",
        status: "Webpage(static)"
    },
    {
        id: 8,
        img: login,
        link: "#",
        status: "Webpage(static)"
    },

    {
        id: 9,
        img: aventon,
        link: "https://aventonconsulting.com.ng/",
        status: "live"
    },
    
    {
        id: 10,
        img: ileojaacademy,
        link: "https://ileojaacademy.ng/",
        status: "live"
    },
    
    {
        id: 11,
        img: electric_shaver,
        link: "https://provenhealth.com.ng/electric-shaver/",
        status: "live sales funnel"
    },
    {
        id: 12,
        img: cleaning_gel,
        link: "https://provenhealth.com.ng/multi-function-cleaning-gel//",
        status: "live sales funnel"
    },
]